import { useCallback } from 'react';

import { useMutation } from '@apollo/client';

import { SEND_REPORT_EMAIL } from '@/types.gql';

import { useToast } from '../toast';

export function useSendReportEmail() {
  const toast = useToast();
  const [sendEmailReport] = useMutation(SEND_REPORT_EMAIL, {
    errorPolicy: 'none',
  });

  return useCallback(
    async ({
      reportUrl,
      recipients,
      subject,
      message,
    }: {
      reportUrl: string;
      subject?: string;
      message: string;
      recipients?: string[];
    }) => {
      const res = await sendEmailReport({
        variables: {
          reportUrl,
          subject: subject ?? null,
          message,
          recipients: recipients ?? null,
        },
      });
      if (res.errors && res.errors.length > 0) {
        console.error('Error sending email report:', res.errors);
        toast.show({
          severity: 'error',
          summary: 'Error sending report email',
        });
      }
    },
    [sendEmailReport, toast],
  );
}
